__webpack_require__.p = "https://fxa.distractionlabs.com/settings/prod/";